// ============================================================================
// LandingPage — switcher between LandingPageV1 (original snap-chart.ai) and
// LandingPageV3 (2026 cyan/purple viral). Uses the shared useDesignVersion()
// hook so the entire site (landing + navbar + dashboard) stays in sync
// based on the admin Site Design toggle.
// ============================================================================
import React from 'react';
import { useDesignVersion } from '@/hooks/useDesignVersion';
import LandingPageV1 from './LandingPageV1';
import LandingPageV3 from './LandingPageV3';

const LandingPage = () => {
  const v = useDesignVersion();
  return v === 'v1' ? <LandingPageV1 /> : <LandingPageV3 />;
};

export default LandingPage;
